import { render, staticRenderFns } from "./competency.vue?vue&type=template&id=63e4a9ca&scoped=true"
import script from "./competency.vue?vue&type=script&lang=js"
export * from "./competency.vue?vue&type=script&lang=js"
import style0 from "./competency.css?vue&type=style&index=0&id=63e4a9ca&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63e4a9ca",
  null
  
)

export default component.exports